import React, { useEffect, useMemo, useState } from "react";
import * as Ionicons from "react-icons/io";
import animetionLogo from "../../../../assets/utils/images/animetion_logo.gif";
import TextareaAutosize from "react-textarea-autosize";
import { Multiselect } from "react-widgets";
import { useMutation, useQuery } from "@apollo/client";
import {
  CHECK_USER_STATUS,
  QUERY_GET_ALL_ACTIVITY,
  QUERY_GET_ALL_COUNTRIES,
  QUERY_GET_FOREIGN_BRANCH_COUNTRIES,
  QUERY_ORG_SUPPORTER_MISSION,
  QUERY_SPECIFIC_SUPPORTER_MISSION,
  QUERY_SUPPORTER_INFORMATION,
  UPDATE_M2M_SUPPORTER,
  UPDATE_SUPPORTER,
} from "../../../../queries";
import { Button, Card, Col, Row } from "reactstrap";
import { useParams } from "react-router-dom";
import { useUserEmail } from "../../../../Layout/AppMain/LoginStatusContext";

const TabOrganizationMission = ({ publicView = false }) => {
  const { supporterId } = useParams();
  const SettingIcon = Ionicons["IoIosSettings"];
  const SyncIcon = Ionicons["IoIosSync"];
  const CloseIcon = Ionicons["IoMdClose"];

  const [editState, setEditState] = useState({
    mission: false,
    sustainabilityPolicy: false,
    colaboration: false,
  });
  const [mission, setMission] = useState("");
  const [sustainabilityPolicy, setSustainabilityPolicy] = useState("");
  const [interestingCounries, setInterestingCounries] = useState([]);
  const [selectedIssues, setSelectedIssues] = useState([]);
  const [
    selectedCorporationCategoryNeeds,
    setSelectedCorporationCategoryNeeds,
  ] = useState([]);
  const [selectedStakeholder, setSelectedStakeholder] = useState([]);

  const { data: checkUserStatus } = useQuery(CHECK_USER_STATUS, {
    variables: {
      email: useUserEmail(),
    },
  });

  const canEdit =
    checkUserStatus?.allUsers?.edges[0]?.node?.supporterRole === "can_edit" ||
    checkUserStatus?.allUsers?.edges[0]?.node?.supporterRole === "CAN_EDIT";

  const allActivity = useQuery(QUERY_GET_ALL_ACTIVITY);
  const orgSupporterMission = useQuery(QUERY_ORG_SUPPORTER_MISSION);
  const specificSupporterMission = useQuery(QUERY_SPECIFIC_SUPPORTER_MISSION, {
    variables: {
      supporterId,
    },
  });
  const supporterInformation = useQuery(QUERY_SUPPORTER_INFORMATION);
  const foreignBranchCountries = useQuery(QUERY_GET_ALL_COUNTRIES);
  const [updateSupporter] = useMutation(UPDATE_SUPPORTER, {
    onCompleted: () => {
      setEditState({
        mission: false,
        sustainabilityPolicy: false,
        colaboration: false,
      });
      orgSupporterMission.refetch();
      supporterInformation.refetch();
      foreignBranchCountries.refetch();
    },
  });
  const [updateM2m] = useMutation(UPDATE_M2M_SUPPORTER, {
    onCompleted: () => {
      setEditState({
        mission: false,
        sustainabilityPolicy: false,
        colaboration: false,
      });
      orgSupporterMission.refetch();
      supporterInformation.refetch();
      foreignBranchCountries.refetch();
    },
  });

  function handleChangeIssue(issue) {
    const isAvailable = selectedIssues.find((x) => x.node.id === issue.node.id);
    if (isAvailable === undefined) {
      setSelectedIssues((prev) => {
        return [...prev, issue];
      });
    } else {
      setSelectedIssues(() => {
        return selectedIssues.filter((x) => x.node.id !== issue.node.id);
      });
    }
  }

  function handleChangeNeed(need) {
    const isAvailable = selectedCorporationCategoryNeeds.find(
      (x) => x.node.id === need.node.id
    );
    if (isAvailable === undefined) {
      setSelectedCorporationCategoryNeeds((prev) => {
        return [...prev, need];
      });
    } else {
      setSelectedCorporationCategoryNeeds(() => {
        return selectedCorporationCategoryNeeds.filter(
          (x) => x.node.id !== need.node.id
        );
      });
    }
  }

  function handleChangeStakeholder(stakeholder) {
    const isAvailable = selectedStakeholder.find(
      (x) => x.node.id === stakeholder.node.id
    );
    if (isAvailable === undefined) {
      setSelectedStakeholder((prev) => {
        return [...prev, stakeholder];
      });
    } else {
      setSelectedStakeholder(() => {
        return selectedStakeholder.filter(
          (x) => x.node.id !== stakeholder.node.id
        );
      });
    }
  }

  useEffect(() => {
    if (!orgSupporterMission?.data) return;
    setMission(
      orgSupporterMission?.data?.allSupporters?.edges[0]?.node?.mission
    );
    setSustainabilityPolicy(
      orgSupporterMission?.data?.allSupporters?.edges[0]?.node
        ?.sustainabilityPolicy
    );
    setInterestingCounries(
      orgSupporterMission?.data?.allSupporters?.edges[0]?.node?.interestingCountry?.edges?.map(
        (branch) => {
          return {
            id: branch?.node?.id,
            nameJp: branch?.node?.nameJp,
          };
        }
      )
    );
    setSelectedIssues(
      orgSupporterMission?.data?.allSupporters?.edges[0]?.node
        ?.interestingActivity?.edges
    );
    setSelectedCorporationCategoryNeeds(
      orgSupporterMission?.data?.allSupporters?.edges[0]?.node
        ?.collaborationNeeds?.edges
    );
    setSelectedStakeholder(
      orgSupporterMission?.data?.allSupporters?.edges[0]?.node
        ?.focusedStakeholders?.edges
    );
  }, [orgSupporterMission]);

  useEffect(() => {
    if (!allActivity.data) return;
  }, [allActivity]);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {orgSupporterMission.loading || specificSupporterMission.loading ? (
        <Card className="mb-2  org_contentarea">
          <div className="loading__wrapper">
            <img
              style={{ width: "80px", margin: "auto" }}
              src={animetionLogo}
            />
          </div>
        </Card>
      ) : (
        <>
          <Card className="mb-2  org_contentarea">
            <div className="org_subtitle_sec">
              <h4 className="org_subtitle">ミッション</h4>
              {editState.mission ? (
                <div style={{ display: "flex" }}>
                  <Button
                    className="ema__btn__update"
                    onClick={async () => {
                      try {
                        await updateSupporter({
                          variables: {
                            mission,
                          },
                        });
                      } catch (err) {
                        alert("正しい入力形式で入力してください");
                      }
                    }}
                  >
                    <SyncIcon fontSize="17px" />
                    <span className="pl-2">更新</span>
                  </Button>
                  <Button
                    style={{ padding: "0.3rem 8px" }}
                    onClick={() => {
                      setEditState({
                        ...editState,
                        mission: !editState.mission,
                      });
                      setMission(
                        orgSupporterMission?.data?.allSupporters?.edges[0]?.node
                          ?.mission
                      );
                    }}
                  >
                    <CloseIcon fontSize="16px" className="pointer" />
                  </Button>
                </div>
              ) : (
                <>
                  {canEdit && (
                    <Button
                      className="ema__btn__edit"
                      {...(publicView && { style: { display: "none" } })}
                      onClick={() => {
                        setEditState({
                          ...editState,
                          mission: true,
                        });
                      }}
                    >
                      <SettingIcon fontSize="20px" />
                      <span className="pl-2">情報の編集</span>
                    </Button>
                  )}
                </>
              )}
            </div>
            {!publicView ? (
              <p className="org_text" style={{ whiteSpace: "pre-wrap" }}>
                {editState?.mission ? (
                  <div className="org_item">
                    <p className="org_text">
                      <TextareaAutosize
                        className="form-control"
                        placeholder="ミッション、ビジョン、バリュー、事業概要（組織が取り組む社会課題の概要とアプローチ方法など）"
                        minRows={3}
                        maxRows={6}
                        defaultValue={mission}
                        value={mission}
                        onChange={(e) => setMission(e.target.value)}
                      />
                    </p>
                  </div>
                ) : (
                  orgSupporterMission?.data?.allSupporters?.edges[0]?.node
                    ?.mission
                )}
              </p>
            ) : (
              <p className="org_text" style={{ whiteSpace: "pre-wrap" }}>
                {specificSupporterMission?.data?.getSpecificSupporter?.mission}
              </p>
            )}
          </Card>
          <Card className="mb-2  org_contentarea">
            <div className="org_subtitle_sec">
              <h4 className="org_subtitle">サステナビリティ／CSR方針</h4>
              {editState.sustainabilityPolicy ? (
                <div style={{ display: "flex" }}>
                  <Button
                    className="ema__btn__update"
                    onClick={async () => {
                      try {
                        await updateSupporter({
                          variables: {
                            sustainabilityPolicy,
                          },
                        });
                      } catch (err) {
                        alert("正しい入力形式で入力してください");
                      }
                    }}
                  >
                    <SyncIcon fontSize="17px" />
                    <span className="pl-2">更新</span>
                  </Button>
                  <Button
                    style={{ padding: "0.3rem 8px" }}
                    onClick={() => {
                      setEditState({
                        ...editState,
                        sustainabilityPolicy: !editState.sustainabilityPolicy,
                      });
                      setSustainabilityPolicy(
                        orgSupporterMission?.data?.allSupporters?.edges[0]?.node
                          ?.sustainabilityPolicy
                      );
                    }}
                  >
                    <CloseIcon fontSize="16px" className="pointer" />
                  </Button>
                </div>
              ) : (
                <>
                  {canEdit && (
                    <Button
                      className="ema__btn__edit"
                      {...(publicView && { style: { display: "none" } })}
                      onClick={() => {
                        setEditState({
                          ...editState,
                          sustainabilityPolicy: true,
                        });
                      }}
                    >
                      <SettingIcon fontSize="20px" />
                      <span className="pl-2">情報の編集</span>
                    </Button>
                  )}
                </>
              )}
            </div>
            {!publicView ? (
              <p className="org_text" style={{ whiteSpace: "pre-wrap" }}>
                {editState.sustainabilityPolicy ? (
                  <div className="org_item">
                    <p className="org_text">
                      <TextareaAutosize
                        className="form-control"
                        placeholder="ミッション、ビジョン、バリュー、事業概要（組織が取り組む社会課題の概要とアプローチ方法など）"
                        minRows={3}
                        maxRows={6}
                        defaultValue={sustainabilityPolicy}
                        value={sustainabilityPolicy}
                        onChange={(e) =>
                          setSustainabilityPolicy(e.target.value)
                        }
                      />
                    </p>
                  </div>
                ) : (
                  orgSupporterMission?.data?.allSupporters?.edges[0]?.node
                    ?.sustainabilityPolicy
                )}
              </p>
            ) : (
              <p className="org_text" style={{ whiteSpace: "pre-wrap" }}>
                {
                  specificSupporterMission?.data?.getSpecificSupporter
                    ?.sustainabilityPolicy
                }
              </p>
            )}
          </Card>
          <Card className="mb-2  org_contentarea">
            <div className="org_subtitle_sec">
              <h4 className="org_subtitle">連携を通じて創造したい価値</h4>
              {editState.colaboration ? (
                <div style={{ display: "flex" }}>
                  <Button
                    className="ema__btn__update"
                    onClick={async () => {
                      try {
                        await updateM2m({
                          variables: {
                            focusedStakeholders: selectedStakeholder.map(
                              (x) => x.node.id
                            ),
                            collaborationNeeds:
                              selectedCorporationCategoryNeeds.map(
                                (x) => x.node.id
                              ),
                            interestingCountry: interestingCounries.map(
                              (x) => x.id
                            ),
                            interestingActivity: selectedIssues.map(
                              (x) => x.node.id
                            ),
                          },
                        });
                      } catch (err) {
                        console.log(err);
                        alert("正しい入力形式で入力してください");
                      }
                    }}
                  >
                    <SyncIcon fontSize="17px" />
                    <span className="pl-2">更新</span>
                  </Button>
                  <Button
                    style={{ padding: "0.3rem 8px" }}
                    onClick={() => {
                      setEditState({
                        ...editState,
                        colaboration: !editState.colaboration,
                      });
                      setInterestingCounries(
                        orgSupporterMission?.data?.allSupporters?.edges[0]?.node?.interestingCountry?.edges?.map(
                          (branch) => {
                            return {
                              id: branch?.node?.id,
                              nameJp: branch?.node?.nameJp,
                            };
                          }
                        )
                      );
                      setSelectedIssues(
                        orgSupporterMission?.data?.allSupporters?.edges[0]?.node
                          ?.interestingActivity?.edges
                      );
                      setSelectedCorporationCategoryNeeds(
                        orgSupporterMission?.data?.allSupporters?.edges[0]?.node
                          ?.collaborationNeeds?.edges
                      );
                      setSelectedStakeholder(
                        orgSupporterMission?.data?.allSupporters?.edges[0]?.node
                          ?.focusedStakeholders?.edges
                      );
                    }}
                  >
                    <CloseIcon fontSize="16px" className="pointer" />
                  </Button>
                </div>
              ) : (
                <>
                  {canEdit && (
                    <Button
                      className="ema__btn__edit"
                      {...(publicView && { style: { display: "none" } })}
                      onClick={() => {
                        setEditState({
                          ...editState,
                          colaboration: true,
                        });
                      }}
                    >
                      <SettingIcon fontSize="20px" />
                      <span className="pl-2">情報の編集</span>
                    </Button>
                  )}
                </>
              )}
            </div>
            <div className="d-flex flex-column" style={{ gap: "8px" }}>
              <p
                className="mb-0 font-weight-bold"
                style={{ fontSize: "14px", marginBottom: "12px" }}
              >
                解決したい社会課題について教えてください
              </p>
              <Row>
                <Col xs="12" md="2" style={{ marginBottom: "8px" }}>
                  <p
                    className="mb-0 font-weight-normal"
                    style={{ fontSize: "13px", color: "#495057" }}
                  >
                    連携・活動したい国は？
                  </p>
                </Col>
                <Col xs="12" md="10">
                  {editState.colaboration ? (
                    <Multiselect
                      dataKey="id"
                      textField="nameJp"
                      defaultValue={interestingCounries}
                      data={foreignBranchCountries?.data?.countries?.edges?.map(
                        (country) => {
                          return {
                            nameJp: country?.node?.nameJp,
                            id: country?.node?.id,
                          };
                        }
                      )}
                      onChange={(e) => {
                        setInterestingCounries(e);
                      }}
                    />
                  ) : (
                    <>
                      {!publicView ? (
                        <p
                          className="mb-0 font-weight-normal"
                          style={{ fontSize: "13px", color: "#000000" }}
                        >
                          {orgSupporterMission?.data?.allSupporters?.edges[0]?.node?.interestingCountry?.edges?.map(
                            (country, index) => {
                              return (
                                <span key={index}>
                                  {index === 0
                                    ? country?.node?.nameJp
                                    : `, ${country?.node?.nameJp}`}
                                </span>
                              );
                            }
                          )}
                        </p>
                      ) : (
                        <p
                          className="mb-0 font-weight-normal"
                          style={{ fontSize: "13px", color: "#000000" }}
                        >
                          {specificSupporterMission?.data?.getSpecificSupporter?.interestingCountry?.edges?.map(
                            (country, index) => {
                              return (
                                <span key={index}>
                                  {index === 0
                                    ? country?.node?.nameJp
                                    : `, ${country?.node?.nameJp}`}
                                </span>
                              );
                            }
                          )}
                        </p>
                      )}
                    </>
                  )}
                </Col>
              </Row>
              <Row>
                <Col xs="12" md="2" style={{ marginBottom: "8px" }}>
                  <p
                    className="mb-0 font-weight-normal"
                    style={{ fontSize: "13px", color: "#495057" }}
                  >
                    注力したい社会課題分野は？
                  </p>
                </Col>
                <Col xs="12" md="10">
                  {!publicView ? (
                    <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                      {allActivity?.data?.allActivityfields?.edges?.map(
                        (issue, index) => {
                          return (
                            <div
                              key={index}
                              onClick={() => {
                                if (!editState.colaboration) return;
                                handleChangeIssue(issue);
                              }}
                              style={{
                                padding: "6px 17px",
                                borderRadius: "5px",
                                backgroundColor:
                                  orgSupporterMission?.data?.allSupporters?.edges?.[0]?.node?.interestingActivity?.edges?.find(
                                    (x) => x?.node?.id === issue?.node?.id
                                  ) &&
                                  selectedIssues.find(
                                    (x) => x?.node?.id === issue?.node?.id
                                  )
                                    ? "#44cae1"
                                    : selectedIssues.find(
                                        (x) => x?.node?.id === issue?.node?.id
                                      )
                                    ? "#44cae180"
                                    : orgSupporterMission?.data?.allSupporters?.edges?.[0]?.node?.interestingActivity?.edges.find(
                                        (x) => x?.node?.id === issue?.node?.id
                                      )
                                    ? "#c4c4c480"
                                    : "#c4c4c4",
                                color: "white",
                                fontSize: "12px",
                                fontWeight: 700,
                                cursor: editState.colaboration
                                  ? "pointer"
                                  : "inherit",
                              }}
                            >
                              <p className="m-0">{issue?.node?.name}</p>
                            </div>
                          );
                        }
                      )}
                    </div>
                  ) : (
                    <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                      {specificSupporterMission?.data?.getSpecificSupporter?.interestingActivity?.edges?.map(
                        (act) => {
                          return (
                            <div
                              style={{
                                padding: "6px 17px",
                                borderRadius: "5px",
                                color: "white",
                                fontSize: "12px",
                                fontWeight: 700,
                                backgroundColor: "#44cae1",
                              }}
                            >
                              <p className="m-0">{act?.node?.name}</p>
                            </div>
                          );
                        }
                      )}
                    </div>
                  )}
                </Col>
              </Row>
              <Row>
                <Col xs="12" md="2" style={{ marginBottom: "8px" }}>
                  <p
                    className="mb-0 font-weight-normal"
                    style={{ fontSize: "13px", color: "#495057" }}
                  >
                    対象としたい課題当事者は？
                  </p>
                </Col>
                <Col xs="12" md="10">
                  {!publicView ? (
                    <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                      {supporterInformation?.data?.allTarget?.edges?.map(
                        (target, index) => {
                          return (
                            <div
                              key={index}
                              onClick={() => {
                                if (!editState.colaboration) return;
                                handleChangeStakeholder(target);
                              }}
                              style={{
                                padding: "6px 17px",
                                borderRadius: "5px",
                                backgroundColor:
                                  orgSupporterMission?.data?.allSupporters?.edges[0]?.node?.focusedStakeholders?.edges.find(
                                    (x) => x?.node?.id === target?.node?.id
                                  ) &&
                                  selectedStakeholder.find(
                                    (x) => x?.node?.id === target?.node?.id
                                  )
                                    ? "#44cae1"
                                    : selectedStakeholder.find(
                                        (x) => x?.node?.id === target?.node?.id
                                      )
                                    ? "#44cae180"
                                    : orgSupporterMission?.data?.allSupporters?.edges[0]?.node?.focusedStakeholders?.edges.find(
                                        (x) => x?.node?.id === target?.node?.id
                                      )
                                    ? "#c4c4c480"
                                    : "#c4c4c4",
                                color: "white",
                                fontSize: "12px",
                                fontWeight: 700,
                                cursor: editState.colaboration
                                  ? "pointer"
                                  : "inherit",
                              }}
                            >
                              <p className="m-0">{target?.node?.name}</p>
                            </div>
                          );
                        }
                      )}
                    </div>
                  ) : (
                    <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                      {specificSupporterMission?.data?.getSpecificSupporter?.focusedStakeholders?.edges?.map(
                        (target) => {
                          return (
                            <div
                              style={{
                                padding: "6px 17px",
                                borderRadius: "5px",
                                color: "white",
                                fontSize: "12px",
                                fontWeight: 700,
                                backgroundColor: "#44cae1",
                              }}
                            >
                              <p className="m-0">{target?.node?.name}</p>
                            </div>
                          );
                        }
                      )}
                    </div>
                  )}
                </Col>
              </Row>
              <Row className="mt-4 mb-2">
                <Col xs={12}>
                  <div
                    style={{
                      fontWeight: "700",
                    }}
                  >
                    社会課題への取組・CSOとの連携で自組織が提供できるコトについて教えてください
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs="12" md="2" style={{ marginBottom: "8px" }}>
                  <p
                    className="mb-0 font-weight-normal"
                    style={{ fontSize: "13px", color: "#495057" }}
                  >
                    提供できる/したい 価値・アセットは？
                  </p>
                </Col>
                <Col xs="12" md="10">
                  {!publicView ? (
                    <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                      {supporterInformation?.data?.allCollaborationNeeds?.edges?.map(
                        (collaborationNeed, index) => {
                          return (
                            <div
                              key={index}
                              onClick={() => {
                                if (!editState.colaboration) return;
                                handleChangeNeed(collaborationNeed);
                              }}
                              style={{
                                padding: "6px 17px",
                                borderRadius: "5px",
                                backgroundColor:
                                  orgSupporterMission?.data?.allSupporters?.edges[0]?.node?.collaborationNeeds?.edges.find(
                                    (x) =>
                                      x?.node?.id ===
                                      collaborationNeed?.node?.id
                                  ) &&
                                  selectedCorporationCategoryNeeds.find(
                                    (x) =>
                                      x?.node?.id ===
                                      collaborationNeed?.node?.id
                                  )
                                    ? "#44cae1"
                                    : selectedCorporationCategoryNeeds.find(
                                        (x) =>
                                          x?.node?.id ===
                                          collaborationNeed?.node?.id
                                      )
                                    ? "#44cae180"
                                    : orgSupporterMission?.data?.allSupporters?.edges[0]?.node?.collaborationNeeds?.edges.find(
                                        (x) =>
                                          x?.node?.id ===
                                          collaborationNeed?.node?.id
                                      )
                                    ? "#c4c4c480"
                                    : "#c4c4c4",
                                color: "white",
                                fontSize: "12px",
                                fontWeight: 700,
                                cursor: editState.colaboration
                                  ? "pointer"
                                  : "inherit",
                              }}
                            >
                              <p className="m-0">
                                {collaborationNeed?.node?.title}
                              </p>
                            </div>
                          );
                        }
                      )}
                    </div>
                  ) : (
                    <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                      {specificSupporterMission?.data?.getSpecificSupporter?.collaborationNeeds?.edges?.map(
                        (collaborationNeed) => {
                          return (
                            <div
                              style={{
                                padding: "6px 17px",
                                borderRadius: "5px",
                                color: "white",
                                fontSize: "12px",
                                fontWeight: 700,
                                backgroundColor: "#44cae1",
                              }}
                            >
                              <p className="m-0">
                                {collaborationNeed?.node?.title}
                              </p>
                            </div>
                          );
                        }
                      )}
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </Card>
        </>
      )}
    </div>
  );
};

export default TabOrganizationMission;
